import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";

const DriversSecondaryHero = loadable(() =>
  import("@lexus.com/ui/dist/modules/DriversSecondaryHero")
);

const ComponentEditConfig = {
  emptyLabel: "Drivers Secondary Hero",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = ({
  heading,
  subHeading,
  defaultBackgroundImage,
  ctas,
}) => ({
  slideSpeed: 5000,
  slides: [
    {
      heading: heading,
      subHeading: subHeading,
      onAssetTextColor: "#fff",
      headingSize: "medium",
      horizontalPosition: "left",
      copyOnMobileAsset: "on",
      media: defaultBackgroundImage,
      ctas: ctas,
    },
  ],
});

const SecondaryHero = (props) => {
  const data = transformData(props);
  return (
  <>
    <DriversSecondaryHero {...data} />
  </>
  );
};

export default withAemIntegration("lexus/components/drivers/drivers-secondary-hero")(SecondaryHero, ComponentEditConfig);